import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import { useTranslation } from 'react-i18next';
import { formatNumberWithCommas } from '@/utils/helpers';
import StatWidgetBox from './StatWidgetBox';
import { useGetBannersQuery } from '@/api/banners';
import { selectActiveBuildingId } from '@/features/building/buildingSlice';
import { useSelector } from 'react-redux';
import TooltipStack from './partials/TooltipStack';
import TooltipContentContainer from './partials/TooltipContentContainer';

const WIDGET_COLOR = '#ffffff';
const WIDGET_TEXT_COLOR = 'rgb(18, 25, 38)';


const RecognitionsChip = ({onClick, open}) => {
  const activeBuildingId = useSelector(selectActiveBuildingId);
  const { data: banner, isLoading } = useGetBannersQuery(activeBuildingId);
  const dayCount = banner?.recognitions?.day_count;
  
  return (
    <StatWidgetBox
      icon={<DirectionsCarIcon sx={{ fontSize: 16 }} />}
      value={formatNumberWithCommas(dayCount) ?? '-'}
      loading={isLoading}
      skeletonWidth={24}
      onClick={onClick}
      tooltipContent={open && <TooltipContent />}
    />
  );
};

const TooltipContent = () => {
  const { t } = useTranslation();
  const activeBuildingId = useSelector(selectActiveBuildingId);
  const { data: banner } = useGetBannersQuery(activeBuildingId);
  return (
    <TooltipContentContainer
      backgroundColor={WIDGET_COLOR}
      backgroundGradient="linear-gradient(140.9deg, rgb(255, 193, 7) -14.02%, rgba(144, 202, 249, 0) 70.5%)"
      icon={<DirectionsCarIcon sx={{ fontSize: 14, color: '255, 193, 7' }} />}
      iconBackground={'rgba(255, 193, 7, 0.3)'}
      iconBorder={'1px solid rgba(255, 193, 7, 0.3)'}
      title={t('recognitions')}
      titleColor={'black'}
    >
      <TooltipStack 
        items={[
          { label: t('month'), value: banner?.recognitions?.month_count },
          { label: t('week'), value: banner?.recognitions?.week_count },
          { label: t('day'), value: banner?.recognitions?.day_count }
        ]} 
        backgroundColor="rgb(255, 193, 7)"
        valueTransformFn={formatNumberWithCommas}
        labelColor={WIDGET_TEXT_COLOR}
        valueColor={WIDGET_TEXT_COLOR}
      />
    </TooltipContentContainer>
    
    
  );
}
export default RecognitionsChip;
